(ns util.string
  (:refer-clojure :exclude [subs replace format])
  (:require
   [clojure.string :as str]
   #?@(:cljs
       [[goog.string :as gstr]]))
  #?(:cljs
     (:require-macros [util.string :refer [expectnil]]))
  #?(:clj
     (:import
      (java.util.regex Pattern)
      (clojure.lang Named))))

;; Shortcuts nil, returns nil
#?(:clj
   (defmacro expectnil [s default & body]
     `(if (nil? ~s) ~default ~@body)))

(def html-map
  {\& "&amp;"
   \< "&lt;"
   \> "&gt;"
   \" "&quot;"})

(defn escape-html
  "Change special characters into HTML character entities."
  [text]
  (str/escape text html-map))

(defn presence
  "Return trimmed string, or nil if it is blank or falsey."
  [x]
  (let [s (str/trim x)]
    (when-not (str/blank? s) s)))

(defn words [s]
  (when-let [s (presence s)]
    (remove str/blank? (str/split s #"\s"))))

(defn safe-name
  "Extended version of `clojure.core/name`, falls back to `toString`"
  [nameable]
  (if #?(:clj (instance? Named nameable)
         :cljs (implements? INamed nameable))
    (name nameable)
    (str nameable)))

(defn titlecase
  "Ensure Formal Capitalisation Of TXT"
  [string]
  (as-> (safe-name string) %
    (str/lower-case %)
    (str/split % #"\s")
    (map (fn [s] (when (pos? (count s)) (apply str (str/upper-case (.substring s 0 1)) (.substring s 1)))) %)
    (str/join "" (interleave % (concat (re-seq #"\s" (safe-name string)) [""])))))

(defn- wrap-index [len x]
  (max 0 (min len (if (neg? x) (+ len x) x))))

(defn subs
  "Alternate to clojure.core/subs that:
   1. Supports negative indices.
   2. Handles length overflow."
  ([s start]
   (let [len (count s)]
     (clojure.core/subs (or s "") (wrap-index len start))))
  ([s start length]
   (let [len (count s)]
     (clojure.core/subs (or s "") (wrap-index len start) (wrap-index len length)))))

(defn join
  ([coll]
   (str/join coll))
  ([separator coll]
   (str/join separator coll)))

(defn split
  ([s delim]
   (expectnil s []
     (str/split s delim)))
  ([s delim n]
   (expectnil s []
     (str/split s delim n))))

(defn split-lines [s]
  (expectnil s []
    (str/split-lines s)))

(defn replace [s match r]
  (expectnil s nil
    (if (nil? match)
      (if (nil? s) r s)
      (str/replace s match r))))

(defn replace-first [s match r]
  (expectnil s (if (nil? match) r s)
    (str/replace-first s match r)))

(defn lower-case [s]
  (expectnil s s
    (str/lower-case s)))

(defn lower [s]
  (lower-case s))

(defn upper-case [s]
  (expectnil s s
    (str/upper-case s)))

(defn upper [s]
  (upper-case s))

(defn trim [s]
  (expectnil s nil
    (str/trim s)))

;; https://github.com/funcool/cuerdas/blob/a4ed2a0404874ad2b46a18bf019af3b0fbd98422/src/cuerdas/regexp.cljc
(defn regex-escape
  "Escapes characters in the string that are not safe
   to use in a RegExp."
  [s]
  #?(:clj (Pattern/quote ^String s)
     :cljs (gstr/regExpEscape s)))

;; https://github.com/funcool/cuerdas/blob/a4ed2a0404874ad2b46a18bf019af3b0fbd98422/src/cuerdas/core.cljc#L250
(defn rtrim
  "Removes whitespace or specified characters
  from right side of string."
  ([s] (rtrim s "\n\t\f\r "))
  ([s chs]
   (when (string? s)
     (let [rxstr (str "[" (regex-escape chs) "]")
           rxstr (str rxstr "+$")]
       (as-> (re-pattern rxstr) rx
         (replace s rx ""))))))

(defn includes? [s substr]
  (expectnil s (= substr nil)
    (str/includes? s substr)))

;; copied from https://github.com/funcool/cuerdas/blob/a4ed2a0404874ad2b46a18bf019af3b0fbd98422/src/cuerdas/core.cljc#L738
(defn- strip-tags-impl
  [s tags mappings]
  (expectnil s nil
    (let [kwdize (comp keyword lower name)
          tags (cond
                 (nil? tags) tags
                 (string? tags) (hash-set (kwdize tags))
                 (sequential? tags) (set (map kwdize tags)))
          rx (re-pattern "<\\/?([^<>]*)>")]
      (replace s rx (if (nil? tags)
                      (fn [[match tag]]
                        (let [tag (kwdize tag)]
                          (get mappings tag "")))
                      (fn [[match tag]]
                        (let [tag (kwdize tag)]
                          (if (tags tag)
                            (get mappings tag "")
                            match))))))))

(defn strip-tags
  "Remove html tags from string."
  ([s] (strip-tags-impl s nil {}))
  ([s tags]
   (if (map? tags)
     (strip-tags-impl s nil tags)
     (strip-tags-impl s tags {})))
  ([s tags mapping]
   (strip-tags-impl s tags mapping)))

(defn starts-with? [s substring]
  (expectnil s (nil? substring)
    (str/starts-with? s substring)))

(defn ends-with? [s substring]
  (expectnil s (nil? substring)
    (str/ends-with? s substring)))

(defn blank? [s]
  (str/blank? s))

;; https://github.com/funcool/cuerdas/blob/a4ed2a0404874ad2b46a18bf019af3b0fbd98422/src/cuerdas/core.cljc#L62
#?(:clj
   (defn slice
     "Extracts a section of a string and returns a new string."
     ([s begin]
      (slice s begin (count s)))
     ([s ^long begin ^long end]
      (when (string? s)
        (let [end (if (< end 0) (+ (count s) end) end)
              begin (if (< begin 0) (+ (count s) begin) begin)
              end (if (> end (count s)) (count s) end)]
          (if (> begin end)
            ""
            (let [begin (if (< begin 0) 0 begin)
                  end (if (< end 0) 0 end)]
              (.substring ^String s begin end)))))))
   :cljs
   (defn slice
     "Extracts a section of a string and returns a new string."
     ([s begin]
      (when (string? s)
        (.slice s begin)))
     ([s begin end]
      (when (string? s)
        (.slice s begin end)))))

;; https://github.com/funcool/cuerdas/blob/a4ed2a0404874ad2b46a18bf019af3b0fbd98422/src/cuerdas/core.cljc#L357
(defn prune
  "Truncates a string to a certain length and adds '...'
  if necessary."
  ([s n] (prune s n "..."))
  ([s n substring]
   (expectnil s s
     (if (<= (count s) n)
       s
       (let [tmpl (fn [c]
                    (if (not= (upper c) (lower c)) "A" " "))
             template (-> (slice s 0 (inc n))
                        (replace #".(?=\W*\w*$)" tmpl))
             tmp (slice template (- (count template) 2))
             template (if #?(:clj (.matches ^String tmp "\\w\\w")
                             :cljs (.match tmp #"\w\w"))
                        (str/replace-first template #"\s*\S+$" "")
                        (rtrim (slice template 0 (dec (count template)))))]
         (if (> (count (str template substring)) (count s))
           s
           (str (slice s 0 (count template)) substring)))))))

(defn format [s & args]
  #?(:clj
     (apply clojure.core/format s args)
     :cljs
     (apply gstr/format s args)))

(defn capitalize [s]
  (expectnil s s
    (str/capitalize s)))

(defn index-of [s substr]
  (expectnil s (if (nil? substr) 0 nil)
    (str/index-of s substr)))

(defn last-index-of [s substr]
  (expectnil s (if (nil? substr) 0 nil)
    (str/last-index-of s substr)))

(defn trim-newline [s]
  (expectnil s s
    (str/trim-newline s)))

(defn edit-distance
  "Levenshtein edit distance between two strings as an integer count of
   single-character edits (PHP levenshtein() parity). nil counts as empty.
   Not to be confused with levenshtein-distance below, which returns a
   0-100 match percentage."
  [s1 s2]
  (let [s1 (str s1)
        s2 (str s2)
        len1 (count s1)
        len2 (count s2)]
    (if (< len1 len2)
      (edit-distance s2 s1)
      (loop [prev-row (vec (range 0 (inc len2)))
             i 0]
        (if (= i len1)
          (peek prev-row)
          (recur
            (reduce
              (fn [row j]
                (conj row
                  (min
                    (inc (nth row (dec j)))
                    (inc (nth prev-row j))
                    (+ (if (= (nth s1 i) (nth s2 (dec j))) 0 1)
                      (nth prev-row (dec j))))))
              [(inc i)]
              (range 1 (inc len2)))
            (inc i)))))))

;; https://gist.github.com/punit-naik/a214a6d4719754ba1ea347022ec5d71b
(defn levenshtein-distance
  "Finds the percentage of match (reversed levenshtein distance & normalised)
   between two strings"
  [s1 s2]
  (let [similarity (atom 0)
        edit-map (atom {})]
    (doseq [i (range (count s1))]
      (let [edit (atom (if (zero? i) 0 i))]
        (doseq [j (range (count s2))]
          (let [e (if (= (.charAt s1 i) (.charAt s2 j)) 0 1)]
            (reset! edit
              (min
                (if (zero? j)
                  (+ i 2)
                  (inc @edit))
                (if (zero? i)
                  (+ j 2)
                  (inc (@edit-map (str (dec i) "," j))))
                (+ (cond
                     (zero? i) j
                     (zero? j) i
                     :else (@edit-map (str (dec i) "," (dec j))))
                  (if (and (zero? i) (zero? j)) 0 e))))
            (swap! edit-map assoc (str i "," j) @edit)
            (when (and (= i (dec (count s1))) (= j (dec (count s2))))
              (reset! edit-map nil)
              (reset! similarity @edit))))))
    (double (- 100 (* 100 (/ @similarity (+ (count s1) (count s2))))))))